module.exports = __webpack_public_path__ + "media/images/brand/qiita_link-4b7329e7c03db301df4b14276abffd91.svg";